import { ILLUSTRATIONS_URL } from './constants';

export type Illustration =
  | '400BadRequest'
  | '401Unauthorized'
  | '403ForbiddenError'
  | '404PageNotFound-1'
  | '404PageNotFound'
  | '500InternalServerError'
  | 'ClearedData'
  | 'Error'
  | 'FirstUse'
  | 'Information'
  | 'Maintenance'
  | 'SearchNotFound'
  | 'Success'
  | 'Warning';

// TODO: Always return the desktop version of the URL for all screen sizes.
export const getIllustrationUrl = (
  name: Illustration,
  isMinTablet?: boolean,
) => {
  return `${ILLUSTRATIONS_URL}/${isMinTablet ? 'desktop' : 'mobile'}/${name}.svg`;
};
